
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/changelogs",
      function () {
        return require("private-next-pages/changelogs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/changelogs"])
      });
    }
  